// extracted by mini-css-extract-plugin
module.exports = {"job-recommendations":"job-recommendations_job-recommendations__QnjCw","job-button":"job-recommendations_job-button__SzCqX"};